import { hash } from 'rsvp';
import { type Registry as Services, service } from '@ember/service';
import type Transition from '@ember/routing/transition';
import ProtectionSettingsController from 'uplisting-frontend/pods/protection/settings/controller';
import PermittedRoute from 'uplisting-frontend/pods/base/permitted-route';

export default class ProtectionSettingsRoute extends PermittedRoute {
  @service('repositories/property')
  propertyRepository!: Services['repositories/property'];

  @service('repositories/guest-identity-verification-configuration')
  guestIdentityVerificationConfigurationRepository!: Services['repositories/guest-identity-verification-configuration'];

  @service('repositories/security-deposit-setting')
  securityDepositSettingRepository!: Services['repositories/security-deposit-setting'];

  @service('repositories/account-configuration')
  accountConfigurationRepository!: Services['repositories/account-configuration'];

  permission = 'automate.identity';

  model() {
    return hash({
      properties: this.propertyRepository.findAll(),
      identityConfiguration:
        this.guestIdentityVerificationConfigurationRepository.getDefaultRecord(),
      securityDepositSettings: this.securityDepositSettingRepository.findAll(),
      accountConfiguration:
        this.accountConfigurationRepository.currentAccountConfiguration,
      stripeConnections: this.store.findAll('stripe-connection'),
    });
  }

  setupController(
    controller: ProtectionSettingsController,
    model,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    const bulkSecurityDepositSetting = this.store.createRecord(
      'bulk-security-deposit-setting',
      {
        securityDepositSettings: model.securityDepositSettings,
      },
    );

    Object.assign(controller, {
      bulkSecurityDepositSetting,
      ...model,
    });

    controller.setDefaultState();
  }

  resetController(
    controller: ProtectionSettingsController,
    isExiting: boolean,
    transition: Transition,
  ): void {
    super.resetController(controller, isExiting, transition);

    this.guestIdentityVerificationConfigurationRepository.unloadAll();
    this.securityDepositSettingRepository.unloadAll();
  }
}
